module.exports = __webpack_public_path__ + "images/academy-onboarding.8e04715ae2ffc2a20caeb98f97e68685.png";